import { useEffect, useRef } from 'react'

const LENGTH = 6

export default function OtpInput({ value = '', onChange, disabled = false, error = false }) {
  const refs = useRef([])
  const digits = Array.from({ length: LENGTH }, (_, i) => value[i] || '')

  useEffect(() => {
    refs.current = refs.current.slice(0, LENGTH)
  }, [])

  function commit(nextDigits) {
    onChange(nextDigits.join('').slice(0, LENGTH))
  }

  function setAt(index, char) {
    const next = digits.slice()
    next[index] = char
    commit(next)
  }

  function handleChange(index, e) {
    const raw = e.target.value.replace(/\D/g, '')
    if (!raw) {
      setAt(index, '')
      return
    }
    if (raw.length > 1) {
      const chars = raw.slice(0, LENGTH - index).split('')
      const next = digits.slice()
      chars.forEach((c, i) => {
        next[index + i] = c
      })
      commit(next)
      const focusIdx = Math.min(index + chars.length, LENGTH - 1)
      refs.current[focusIdx]?.focus()
      return
    }
    setAt(index, raw)
    if (index < LENGTH - 1) refs.current[index + 1]?.focus()
  }

  function handleKeyDown(index, e) {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      e.preventDefault()
      setAt(index - 1, '')
      refs.current[index - 1]?.focus()
    }
    if (e.key === 'ArrowLeft' && index > 0) {
      e.preventDefault()
      refs.current[index - 1]?.focus()
    }
    if (e.key === 'ArrowRight' && index < LENGTH - 1) {
      e.preventDefault()
      refs.current[index + 1]?.focus()
    }
  }

  function handlePaste(e) {
    e.preventDefault()
    const pasted = (e.clipboardData.getData('text') || '').replace(/\D/g, '').slice(0, LENGTH)
    if (!pasted) return
    const next = Array.from({ length: LENGTH }, (_, i) => pasted[i] || '')
    commit(next)
    refs.current[Math.min(pasted.length, LENGTH) - 1]?.focus()
  }

  return (
    <div className="otp-row" role="group" aria-label="One-time code">
      {digits.map((digit, i) => (
        <input
          key={i}
          ref={(el) => {
            refs.current[i] = el
          }}
          className={`otp-input${error ? ' err' : ''}`}
          type="text"
          inputMode="numeric"
          autoComplete={i === 0 ? 'one-time-code' : 'off'}
          maxLength={1}
          value={digit}
          disabled={disabled}
          aria-label={`Digit ${i + 1}`}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
        />
      ))}
    </div>
  )
}
